import type { Address, CompanyLookup } from '@/shared/api/resources';
import {
  digitosIguais,
  enderecoEmTexto,
  enderecoVazio,
  mesmoEndereco,
  type CampoDaReceita,
} from '@/shared/lib/consultaCnpj';

/**
 * De onde vem cada campo do cadastro simples do corretor na consulta de CNPJ
 * (ADR 0092). A corretora de seguros e empresa comum na Receita: a fonte e a mesma do
 * tomador. O formulario simples so tem estes campos da empresa; situacao do CNPJ,
 * CNAE e natureza juridica ficam na ficha do corretor e no assistente de cadastro.
 */
export type CampoDoCorretor =
  'legal_name' | 'trade_name' | 'email' | 'phone' | 'address';

export interface ValoresDoCorretor {
  legal_name: string;
  trade_name: string;
  email: string;
  phone: string;
  address: Address;
}

/** O endereco da Receita no contrato do corretor, que nao tem o codigo IBGE. */
export function enderecoDoCorretor(r: CompanyLookup): Address {
  return {
    zip_code: r.address.zip_code,
    street: r.address.street,
    number: r.address.number,
    complement: r.address.complement,
    district: r.address.district,
    city: r.address.city,
    state: r.address.state,
  };
}

export function camposDoCorretorDaReceita(
  atual: ValoresDoCorretor,
  r: CompanyLookup,
): CampoDaReceita<CampoDoCorretor>[] {
  const endereco = enderecoDoCorretor(r);
  return [
    {
      chave: 'legal_name',
      rotulo: 'Razao social',
      atual: atual.legal_name,
      receita: r.legal_name,
    },
    {
      chave: 'trade_name',
      rotulo: 'Nome fantasia',
      atual: atual.trade_name,
      receita: r.trade_name,
    },
    { chave: 'email', rotulo: 'Email', atual: atual.email, receita: r.email },
    {
      chave: 'phone',
      rotulo: 'Telefone',
      atual: atual.phone,
      receita: r.phone,
      igual: digitosIguais,
    },
    {
      chave: 'address',
      rotulo: 'Endereco',
      atual: enderecoVazio(atual.address) ? '' : enderecoEmTexto(atual.address),
      receita: enderecoEmTexto(endereco),
      igual: () => mesmoEndereco(atual.address, endereco),
    },
  ];
}
